const statusOtp = {
    valid: 0,
    invalid: 1,
    expired: 2,
    maxRetries: 3
};

export default {
    statusOtp
};